import React, { Fragment } from "react";
import Footer from "../../Shear/Footer/Footer";
import Header from "../../Shear/Header/Header";
import { Link } from "react-router-dom";
import blog from "../../../Data/blog";
import Head from "../../../layout/Head";
import ScrollToTop from "../../Shear/ScrollToTop";

const Blog = () => {
  return (
    <Fragment>
      <Head
        Title="Blog"
        href="/blog"
        description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | Blog Pages"
      />
      <Header />
      <section className="max-w-[1000px] px-2 max-sm:px-20   max-lg:px-0  max-xl:max-w-[1200px] mx-auto py-10">
        <button className="custom_button2">
          <span>Blog ~</span>
        </button>
        <h2 className=" mb-[28px] leading-[38px]  max-sm:leading-[1.1428] color-[#000001] font-fira font-bold text-[25px] max-sm:text-[42px]">
          Our Latest <span className="text-secondary">Blog</span>
        </h2>

        <div className="grid max-sm:grid-cols-2 max-lg:grid-cols-3 mb-[50px] justify-center items-center gap-7">
          {blog.map((data) => (
            <article
              className="bg-[#fff] cursor-pointer overflow-hidden"
              style={{ boxShadow: "0 0 21px rgb(1 1 72 / 6%)" }}
              key={data.id}
            >
              <img src={data.images[0]} alt="IT Ghar" />
              <div className="px-[30px] py-5">
                <p className="flex justify-start items-center text-sm text-[#666] mb-[5px]">
                  <i className="fas fa-calendar-alt text-linear-gradient text-xs mr-[6px]"></i>
                  {data.date}
                </p>
                <h3 className="text-xl text-[#0e0d0f] mb-2 font-bold font-fira">
                  {data.title}
                </h3>

                <div className="border-t border-[#eaeaea] pt-[15px] flex justify-between items-center">
                  <div className="flex justify-center items-center">
                    <img
                      className="w-[38px] mx-auto mr-2 rounded-[50%] h-[38px]"
                      src={data.author.image}
                      style={{ boxShadow: "0 2px 2px rgb(15 103 246 / 30" }}
                      alt="IT Ghar"
                    />
                    <span className="text-[#0e0d0f] font-medium text-base">
                      {data.author.fullName}
                    </span>
                  </div>
                  <div>
                    <Link
                      to={`/blog-details/${data.id}`}
                      className="border-b leading-[1] text-[#0e0d0f] text-[15px] font-bold mr-2 border-[#8a898a]"
                    >
                      More Details{" "}
                    </Link>
                    <i className="fas fa-arrow-right text-[13px] text-linear-gradient"></i>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
      <ScrollToTop />
      <Footer />
    </Fragment>
  );
};

export default Blog;
